<api-call-gate
  [apiCall]="mrqDashboardApi"
  [params]="{
    systemSerialNumber: systemSerialNumber,
    systemMaterialNumber: systemMaterialNumber,
  }"
>
  <ng-template #lastSuccessfulData>
    <div class="mrq-table-container">
      @if (loading) {
        <div class="loading-indicator">
          <sh-spinner></sh-spinner>
        </div>
      }

      @if (!loading && reportData.length === 0) {
        <div class="empty-state">
          <app-no-data-icon
            iconName="url('/portal/assets/success-dashed.svg')"
            error="No MRQ data available for this system"
          ></app-no-data-icon>
        </div>
      }

      @if (screenLayoutService.phone$ | async) {
        @if (!loading && reportData.length > 0) {
          <app-mrq-mobile-table
            [reportData]="reportData"
            [columns]="columns"
            [magnetType]="magnetType"
          ></app-mrq-mobile-table>
        }
      } @else {
        @if (!loading && reportData.length > 0) {
          <div class="table-container">
            <div class="mat-table-container">
              <table
                mat-table
                [dataSource]="matTableDataSource"
                matSort
                (matSortChange)="onMatSortChange($event)"
              >
                <!-- Date Column -->
                <ng-container matColumnDef="date">
                  <th mat-header-cell *matHeaderCellDef>Date</th>
                  <td
                    mat-cell
                    *matCellDef="let row"
                    [app-weekend-highlight]="row.date"
                  >
                    {{ row.date | localizedDate }}
                  </td>
                </ng-container>

                <!-- Dynamic Columns -->
                @for (column of columns.slice(1); track column.id) {
                  <ng-container [matColumnDef]="column.id">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      [matTooltip]="column.tooltip || ''"
                    >
                      {{ capitalizeHeader(column.id) }}
                    </th>
                    <td mat-cell *matCellDef="let row">
                      {{ emptyValueCheck(row.values[column.id]) }}
                    </td>
                  </ng-container>
                }
                <!-- Headers -->
                <tr
                  class="table-header-text"
                  mat-header-row
                  *matHeaderRowDef="displayedColumns"
                ></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"
                ></tr>
              </table>
            </div>
          </div>
        }
      }
    </div>
  </ng-template>
</api-call-gate>
